<script>
    import HomePageActivities from './HomePageActivities.svelte';
    import HomePageSchedule from './HomePageSchedule.svelte';
    import HomePageElements from './HomePageElements.svelte';
    import OpenImprovements from './OpenImprovements.svelte';

    export let branch;
    export let branchId;

    export let workOrderAutomationEnabled = false;

</script>

<HomePageActivities {branch} {branchId} />
<HomePageSchedule {branch} {branchId} {workOrderAutomationEnabled} />
<HomePageElements {branch} {branchId} />
<OpenImprovements {branch} {branchId} />
